import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfirmationModule } from '@challenger/care/components/confirmation/confirmation.module';
import { PageHeadingModule } from '@challenger/care/components/page-heading/page-heading.module';
import { StrapiGenericComponentService } from '@challenger/care/services/strapi-generic-component.service';
import { WorkflowService } from '@challenger/care/services/workflow.service';
import { LoadingScreenModule } from '@challenger/care/components/loading-screen/loading.module';
import { ContactUsModule } from '@challenger/care/journeys/contact-us/contact-us.module';
import { CarouselModule } from '@challenger/care/components/carousel/carousel.module';
import { CarouselComponent } from '@challenger/care/components/carousel/carousel.component';
import { GenericTilesModule } from '@challenger/care/components/generic-tiles/generic-tiles.module';

import { SEOFlowRoutingModule } from './seo-flow-routing.module';
import { SEOFlowShellComponent } from './containers/seo-flow-shell/seo-flow-shell.component';
import { AdviceComponent } from './components/advice/advice.component';
import { ArticleComponent } from './components/article/article.component';
import { ArticleShellComponent } from './containers/article-shell/article-shell.component';
import { AdviceShellComponent } from './containers/advice-shell/advice-shell.component';
import { ContactUsWrapperComponent } from './containers/contact-us-wrapper/contact-us-wrapper.component';

@NgModule({
  declarations: [
    SEOFlowShellComponent,
    AdviceShellComponent,
    AdviceComponent,
    ArticleShellComponent,
    ArticleComponent,
    ContactUsWrapperComponent
  ],
  imports: [
    SEOFlowRoutingModule,
    CommonModule,
    ConfirmationModule,
    PageHeadingModule,
    LoadingScreenModule,
    ContactUsModule,
    CarouselModule,
    GenericTilesModule
  ],
  providers: [
    WorkflowService,
    StrapiGenericComponentService,
    CarouselComponent,    
  ],
})
export class SEOFlowModule {}
